import { cn } from '@gettactic/helpers';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

export type PopoverProps = React.ComponentProps<typeof PopoverPrimitive.Root>;

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

export interface PopoverContentProps
  extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  arrowProps?: PopoverPrimitive.PopoverArrowProps;
  showArrow?: boolean;
  withTriangle?: boolean;
}

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(
  (
    {
      className,
      arrowProps,
      withTriangle = false,
      children,
      align = 'center',
      sideOffset = 4,
      showArrow = true,
      ...props
    },
    ref
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-popover min-w-72 rounded-md bg-white p-4 text-popover-foreground shadow-md outline-none data-[state=closed]:animate-out data-[state=open]:animate-in',
          className
        )}
        {...props}
      >
        {children}
        {showArrow && (
          <PopoverPrimitive.Arrow
            width={25}
            height={15}
            {...arrowProps}
            className={cn('fill-white dark:fill-black', arrowProps?.className)}
          />
        )}
        {withTriangle && (
          <PopoverPrimitive.Arrow
            width={25}
            height={15}
            {...arrowProps}
            className={cn('fill-white dark:fill-black', arrowProps?.className)}
          />
        )}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  )
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
